export default __webpack_public_path__ + "static/media/logo_satellite_primary_white_stacked_beta.e25c7b88.png";